<template>
  <l-marker
    :lat-lng="latLng"
    :icon="icon"
    :class="active ? 'is-active' : ''"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <slot />
  </l-marker>
</template>

<script>
import L from "leaflet";
import { LMarker } from "vue2-leaflet";

export default {
  name: "eo-map-icon",
  props: {
    latLng: {
      type: Object
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      const fill = this.active
        ? this.$store.state.mapPinFillColorActive
        : this.$store.state.mapPinFillColor;
      const stroke = this.active
        ? this.$store.state.mapPinStrokeColorActive
        : this.$store.state.mapPinStrokeColor;

      return L.divIcon({
        className: "eoev-map-marker",
        html:
          '<svg xmlns="http://www.w3.org/2000/svg" height="39" width="26" class="svg-icon-svg"><path d="M18.2 13a5.2 5.2 0 01-5.2 5.2A5.2 5.2 0 017.8 13 5.2 5.2 0 0113 7.8a5.2 5.2 0 015.2 5.2zM.5 13L13 38l12.5-25a12.5 12.5 0 00-25 0z" fill="' +
          fill +
          '" stroke="' +
          stroke +
          '"/></svg>',
        iconSize: [26, 39],
        iconAnchor: [13, 39],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
      });
    }
  },
  components: {
    LMarker
  },
  methods: {
    onMouseEnter() {
      // bubble event
      this.$emit("mouseenter");
    },
    onMouseLeave() {
      // bubble event
      this.$emit("mouseleave");
    }
  }
};
</script>

<style lang="sass">
// .eoev-map-marker
</style>
